import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { useCallback, useMemo } from "react"

import { UseIdFilterProps, UseIdFilterRes } from "./types/useFilter.types"
import { UUID } from "../../classes/uuid"

export function useIdFilter<TValue extends { id?: PBUUID }>(
  props: UseIdFilterProps<TValue>
): UseIdFilterRes {
  const { useFilter, ...restProps } = props

  const keyExtractor = useCallback(({ id }: TValue) => UUID.idString(id), [])

  const res = useFilter({
    ...restProps,
    keyExtractor,
  })

  const selected = useMemo<PBUUID[]>(
    () => res.selectedKeys.map((id) => UUID.fromString(id)),
    [res.selectedKeys]
  )

  return {
    ...res,
    selected,
  }
}
